import axios from 'axios';

function getVersionId() {
  const MS_PER_DAY = 86400000;

  const currentTimestamp = new Date().getTime();

  return Math.floor(currentTimestamp / MS_PER_DAY);
}

async function fetchV1Customers() {
  try {
    return (
      await axios.get(
        `https://letsbook.com.br/customers_lets_sites-v1.json?v=${getVersionId()}`,
      )
    ).data;
  } catch (err) {
    return [];
  }
}

export default async function isV1Customer(customer) {
  const customers = await fetchV1Customers();

  return customers.includes(customer);
}
